<template>
    <div>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="location_in_id" class="form-label">Odredišna lokacija</label>
                <input type="hidden" name="location_in_id" :value="(selected_location_in == undefined) ? '' :
                selected_location_in.value">
                <v-select id="location_in_id"
                    :filterable="false"
                    v-model="selected_location_in"
                    :disabled="disableEdit()"
                    :options="location_in"
                    :clearable="false"
                    @search="locationInSearch"
                >
                    <template slot="no-options">
                        Pretraživanje lokacija
                    </template>
                </v-select>
            </div>
        </div>

        <div class="flex -xm-1 mb-4" v-if="item.status == 'draft'">
            <div class="form-group w-full">
                <div class="mt-8">
                    <span>Dodavanje serijskih brojeva iz dodanih datoteka se vrši isključivo prilikom potvrde primke.</span><br>
                    <a :href="xlsExample" download>Ovdje možete preuzeti primjer XLS datoteke za unos serijskih brojeva.</a>
                </div>
            </div>
        </div>

        <div class="flex -mx-1 mb-4 mt-8"  v-for="(product, index) in products" :key="'product-' + index">
            <div class="form-group w-1/3 pl-1 pr-8">
                <label for="selected_product" class="form-label">Odaberi uređaj</label>
                <v-select
                    id="selected_product"
                    :filterable="false"
                    v-model="products[index]"
                    :disabled="disableEdit()"
                    :options="allProducts"
                    :clearable="false"
                    @search="productsSearch"
                >
                    <template slot="no-options">
                        Pretraživanje tipova opreme
                    </template>
                </v-select>
            </div>
            <div class="form-group w-1/6 pl-1 pr-8">
                <label :for="'quantity-'+ index" class="form-label">Unesi količinu</label>
                <input type="number"
                       min="0"
                       class="form-control"
                       :id="'quantity-'+ index"
                       :disabled="disableEdit()"
                       v-model="products[index].quantity">
            </div>

            <div class="form-group w-1/6 pr-8" v-if="products[index].type == 'material' || products[index].type == 'spare'">
                <label :for="'price-'+ index" class="form-label">Unesi nabavnu cijenu</label>
                <input type="number"
                       min="0"
                       class="form-control"
                       :id="'price-'+ index"
                       :disabled="disableEdit()"
                       step=".01"
                       v-model="products[index].price">
            </div>

            <div v-if="!product.track_quantitatively" class="flex items-center justify-center pt-8">
                <div v-if="(item.status == 'confirmed' || item.status == 'received')" class="ml-auto flex items-center justify-center">
                    <span
                        :for="'remove-product-' + index"
                        class="_remove mb-0 font-bold"
                    >Dodano je {{ serialNumberCount(product.qr_codes) }} uređaja sa serijskim brojem</span>
                </div>
            </div>

            <div
                class="flex items-center justify-center pt-8 mr-4"
                v-if="product.track_quantitatively"
            >
                <span>Oprema se prati količinski</span>
            </div>

            <div class="flex items-center justify-center pt-8">
                <div
                    v-if="(item.status == 'draft' || createForm) && !lessThanTwo()"
                    class="ml-auto flex items-center justify-center"
                >
                    <label
                        :for="'remove-product-' + index"
                        class="form-label _remove mb-0"
                    >Ukloni uređaj</label>
                    <button
                        :id="'remove-product-' + index"
                        type="button"
                        class="btn btn-delete border-0 my-0 py-0 px-2 hover:text-primary"
                        @click="removeProduct(index)"
                    ></button>
                </div>
            </div>

            <div class="flex items-center justify-center pt-8 ml-8" v-if="item.status == 'draft' && !product.track_quantitatively">
                <div class="ml-auto flex items-center justify-center">
                    <button
                        :id="'file-import-button-' + index"
                        type="button"
                        @click="chooseFile('serialImport[' + index + ']')"
                        class="review-link mr-2"
                    >Dodaj datoteku</button>

                    <a :id="'file-name-' + index" class="pt-1 mx-2 qr-file-name"></a>
                    <input
                        :id="'serialImport[' + index + ']'"
                        :name="'serialImport[' + index + ']'"
                        style="display: none;"
                        type="file"
                        class="border-0 my-0 py-0 px-2 hover:text-primary"
                        @input="setFilename(index, $event, product)"
                    />
                </div>
            </div>
        </div>

        <span v-for="(product, index) in products" :key="'h_product-' + index">
            <input
                type="hidden"
                :name="'products[' + index + '][id]'"
                :value="product.value"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][quantity]'"
                :value="product.quantity"
            >
            <input
                v-if="product.price"
                type="hidden"
                :name="'products[' + index + '][price]'"
                :value="product.price"
            >
        </span>

        <div v-if="!hideShipped" class="flex -mx-1 mb-4 mt-8 justify-between">
            <button
                class="btn btn-lg btn-success btn-yellow"
                :disabled="disableEdit()"
                @click.prevent="addNewProduct()"
            >
                <span>Dodaj novi uređaj</span>
            </button>
        </div>

        <hr>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 px-1">
                <label for="remark" class="form-label">Napomena</label>
                <textarea
                    class="form-control min-h-remark"
                    name="remark"
                    :disabled="item.status == 'shipped' || item.status == 'received'"
                    :value="remark"
                ></textarea>
            </div>
        </div>

        <hr>
        <div class="flex justify-end">
            <div class="mr-4" v-if="item.status == 'draft'">
                <button v-if="!allProductsHaveFiles"
                    name="change_status"
                    value="confirmed"
                    class="btn btn-lg btn-success flex ml-auto"
                    type="button"
                    @click="showConfirmModal"
                    :disabled="disableSubmit()"
                >
                    <span>Potvrdi primku</span>
                </button>
                <button v-else
                    name="change_status"
                    value="confirmed"
                    class="btn btn-lg btn-success flex ml-auto"
                    :disabled="disableSubmit()"
                >
                    <span>Potvrdi primku</span>
                </button>
            </div>

            <div class="mr-4" v-if="item.status == 'confirmed' && ableToReceiveReceipt">
                <button
                    name="change_status"
                    value="received"
                    class="btn btn-lg btn-success flex ml-auto"
                    :disabled="disableSubmit()"
                >
                    <span>Zaprimi</span>
                </button>
            </div>

            <div v-if="item.status != 'confirmed' && item.status != 'received'">
                <button
                    class="btn btn-lg btn-success flex ml-auto"
                >
                    <img src="/svg/confirm.svg" alt="confirm" class="mr-2">
                    <span v-text="pageTitle"></span>
                </button>
            </div>
        </div>

        <modal
            v-if="confirmModalVisible"
        >
            <div slot="header">
                <h2>Upozorenje!</h2>
            </div>
            <div v-if="requiresAnyQrCodes" slot="body">
                <span>Sljedećim proizvodima nisu dodjeljeni serijski brojevi:</span>
                <div
                    v-for="product in products"
                    :key="product.id"
                >
                    <span v-if="!product.hasFile && !product.track_quantitatively">{{ product.label }}</span><br>
                </div>
                <br>
                <span>Želite li svejedno nastaviti?</span>
            </div>
            <div v-else slot="body">
                <span>Želite li potvrditi primku?</span>
            </div>
            <div class="flex" slot="footer">
                <button
                    class="btn btn-success mx-2"
                    name="change_status"
                    value="confirmed"
                >Potvrdi</button>
                <button
                    class="btn border-gray-500 mx-2"
                    type="button"
                    v-on:click="hideConfirmModal"
                >Odustani</button>
            </div>
        </modal>

    </div>
</template>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    import Modal from './Modal';

    Vue.component('v-select', vSelect)

    export default {
        components: {
            Modal,
        },

        props: {
            createForm: {
                type: Boolean,
                default: false,
            },
            ableToReceiveReceipt: {
                type: Boolean,
                default: false,
            },
            xlsExample : {
                type: String,
            },
            productsAndQr: {
                type: Array,
                default: () => ([])
            },
            pageTitle: {
                type: String,
                default: null
            },
            selectedLocationOut: {
                type: Object,
                default: () => ({})
            },
            selectedLocationIn: {
                type: Object,
                default: () => ({})
            },
            item: {
                type: Object,
                default: () => ({})
            },
            remark: {
                type: String,
                default: ''
            },
            user: {
                type: Object,
                default: () => ({})
            }
        },

        data () {
            return {
                fileNames: [],
                hideShipped: false,
                location_out: [],
                location_in: [],
                equipmentQr: [],
                allProducts: [],
                products: [],
                selectedEquipmentQr: null,
                selected_location_in: null,
                selected_products: [],
                quantityDifference: [],
                itemData: null,
                authorisedUserRole: [],
                confirmModalVisible: false,
                allProductsHaveFiles: false,

            }
        },

        created() {
            this.authorisedUserRole = this.user.role_key;
            this.selected_location_in = this.selectedLocationIn;
            this.selected_location_out = this.selectedLocationOut;
            this.itemData = this.item;
            this.products = this.productsAndQr;
            this.initProducts()
            this.products.forEach((product) => {
                product.hasFile = false;
            });
        },

        mounted() {
            if (this.item.status == 'ship_request' || this.item.status == 'shipped') {
                this.hideShipped = true
            }

            this.locationOutSearch('', '')
            this.locationInSearch('', '')
            this.productsSearch('', '')
        },

        computed: {
            requiresAnyQrCodes() {
                let requiresQrCodes = false;

                this.products.forEach((product) => {
                    if (!product.track_quantitatively && !requiresQrCodes) {
                        requiresQrCodes = true;
                    }
                })

                return requiresQrCodes;
            }
        },

        methods: {
            checkAllProductsHaveFiles() {
                let listOfProductsWithoutFiles = []

                this.products.forEach((product) => {
                    if (product.hasFile === false) {
                       listOfProductsWithoutFiles.push(product)
                    }
                })

                if (listOfProductsWithoutFiles.length) {
                    this.allProductsHaveFiles = false
                } else {
                    this.allProductsHaveFiles = true
                }
            },

            showConfirmModal() {
                this.confirmModalVisible = true
            },

            hideConfirmModal() {
                this.confirmModalVisible = false
            },

            setFilename(index, event, product) {
                this.fileNames[index] = event.target.files[0].name
                this.products.forEach((prod) => {
                    if (prod == product) {
                        prod.hasFile = true
                    }
                })

                this.checkAllProductsHaveFiles()

                document.getElementById('file-name-' + index).innerHTML = event.target.files[0].name
            },

            chooseFile(id) {
                document.getElementById(id).click()
            },

            lessThanTwo() {
                if (this.products.length < 2) {
                    return true
                }

                return false
            },

            withoutSerialNumber(data) {
                let withoutSerial = 0

                data.forEach(element => {
                    if (!element.serial_no) {
                        withoutSerial++
                    }
                });

                return withoutSerial
            },

            serialNumberCount(data) {
                let serialNoCount = 0

                data.forEach(element => {
                    if (element.serial_no) {
                        serialNoCount++
                    }
                });

                return serialNoCount
            },

            removeProduct(index) {
                this.products.splice(index, 1)
                this.checkAllProductsHaveFiles()
            },

            initProducts() {
                if (this.products.length === 0) {
                    this.addNewProduct()
                }
            },

            addNewProduct() {
                this.products.push({
                    label: '',
                    value: null,
                    quantity: 0,
                    qr_codes: [],
                    hasFile: false,
                });

                this.checkAllProductsHaveFiles()
            },

            locationOutSearch(search, loading) {
                this.isOutSearchLoading = true;
                fetch('/api/search/locations/' + escape(search))
                    .then(res => res.json())
                    .then(json => {
                        this.location_out = json.data;
                        this.isOutSearchLoading = false;
                    })
                    .catch(err => console.warn(err));
            },

            locationInSearch(search, loading) {
                this.isInSearchLoading = true;
                fetch('/api/search/locations/' + escape(search))
                    .then(res => res.json())
                    .then(json => {
                        this.location_in = json.data;
                        this.isInSearchLoading = false;
                    })
                    .catch(err => console.warn(err));
            },

            productsSearch(search, loading) {
                this.isInSearchLoading = true;
                fetch('/api/all-products/' + escape(search))
                    .then(res => res.json())
                    .then(json => {
                        this.allProducts = json.data;
                        this.isInSearchLoading = false;
                    })
                    .catch(err => console.warn(err));
            },

            qrCodeSearch(search, loading) {
                this.isInSearchLoading = true;
                fetch('/api/search/qr-code/' + this.selected_location_out.value + '/' + escape(search))
                    .then(res => res.json())
                    .then(json => {
                        this.equipmentQr = json.data;
                        this.isInSearchLoading = false;
                    })
                    .catch(err => console.warn(err));
            },

            equipmentSelected() {
                if (this.selectedEquipmentQr) {
                    return true
                }

                return false
            },

            locationsSelected() {
                if (this.selected_location_in && this.selected_location_out) {
                    return true
                }

                return false
            },

            disableSubmit() {
                if (
                    Object.keys(this.selected_location_in).length !== 0
                ) {

                    return false
                }

                return true
            },

            disableQrSelection() {
                if (this.disableEdit()) {
                    return true
                } else if (!this.selected_location_out.value) {
                    return true
                }

                return false
            },

            disableEdit() {
                if (
                    this.itemData.status == 'draft' ||
                    this.itemData.status === undefined
                ) {
                    return false
                }

                return true
            },

            removeQr(index, qrIndex) {
                this.products[index]['qr_codes'].splice(qrIndex, 1);
            },

            addEquipment() {
                let arrayLength = this.products.length;
                for (let i = 0; i < arrayLength; i++) {
                    if (this.products[i]['value'] == this.selectedEquipmentQr.product_id) {
                        if (this.products[i]['qr_codes'].length == this.products[i]['quantity']) {
                            alert('Već su dodani svi QR kodovi za ' + this.products[i]['label']);
                        } else if (this.products[i]['qr_codes'].length > this.products[i]['quantity']) {
                            alert('Već je dodano previše QR kodova za ' + this.products[i]['label']);
                        } else {
                            this.products[i]['qr_codes'].push({
                                label: this.selectedEquipmentQr.label,
                                value: this.selectedEquipmentQr.value,
                                code: this.selectedEquipmentQr.code,
                            });
                        }
                    }
                }

                this.selectedEquipmentQr = null
            },

            productDiff(productId) {
                let countProducts = 0;

                let arrayLength = this.equipment.length;
                for (let i = 0; i < arrayLength; i++) {
                    if (this.equipment[i]['product_id'] == productId) {
                        countProducts += 1;
                    }
                }

                let productQuantity = (this.products_quantity[productId]) ?
                    parseInt(this.products_quantity[productId]) : 0;

                let diff = productQuantity - countProducts;

                if (!diff) {
                    return 'Ok'
                } else if (diff < 0) {
                    return (diff*-1) + ' više dodano'
                } else {
                    return diff + ' treba dodati'
                }
            }
        },
    }
</script>
